import { render, staticRenderFns } from "./ProjectDefect.vue?vue&type=template&id=721d746e&scoped=true"
import script from "./ProjectDefect.vue?vue&type=script&lang=js"
export * from "./ProjectDefect.vue?vue&type=script&lang=js"
import style0 from "./ProjectDefect.vue?vue&type=style&index=0&id=721d746e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721d746e",
  null
  
)

export default component.exports